const note = {
    version: '1.0.2',
    date: '2026-09-01',
    tags: ['Fix'],
    body: `
- **En timelog uden varighed fylder ikke hele dagen.** En timelog på nul minutter blev tegnet som 23 timer og fik dagens total til at se forkert ud.
`,
};

export default note;
